import React from "react";
import 'react-image-gallery/styles/css/image-gallery.css'
import PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";
import {BACKEND_URL} from "../../../../../../util/api";
import {formatDateTime} from "../../../../../../util/datetime";
import renderImageArea from "../renderer/renderImageArea";
import renderThumbnail from "../renderer/renderThumbnail";

const moment = require('moment')

const compareImageVersion = (a, b) => {
    a = a.lastModified
    b = b.lastModified
    if (!a && !b) {
        return 0
    }
    if (!a && b) {
        return -1
    }
    if (a && !b) {
        return 1
    }
    return moment(a).unix() - moment(b).unix()
}

const ImageVersionGallery = ({
                                 imageVersionList,
                                 rotateCustomerImage,
                                 image,
                                 setImageTypeMetaData,
                                 customerId,
                                 handleOnSlide,
                                 startIndex
                             }) => {
    imageVersionList.sort(compareImageVersion);

    const imageList = imageVersionList.map(version => {
        return {
            path: version.path,
            original: BACKEND_URL + version.link,
            thumbnail: BACKEND_URL + version.link,
            lastModified: formatDateTime(version.lastModified),
            fileName: image.name,
            versionId: version.versionId,
            rotate:
                version.meta && version.meta.rotate ? version.meta.rotate : 0,
            originalImageType: version.originalImageType,
            image,
            rotateCustomerImage,
            setImageTypeMetaData,
            customerId,
        }
    })

    return (
        <ImageGallery
            startIndex={startIndex}
            renderItem={renderImageArea}
            infinite={false}
            items={imageList}
            renderThumbInner={renderThumbnail}
            onSlide={handleOnSlide.bind(this)}
        />
    )
}

ImageVersionGallery.propTypes = {
    imageVersionList: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    rotateCustomerImage: PropTypes.func.isRequired,
    image: PropTypes.object,
    setImageTypeMetaData: PropTypes.func.isRequired,
    customerId: PropTypes.string,
    handleOnSlide: PropTypes.func.isRequired,
    startIndex: PropTypes.number
};

export default ImageVersionGallery;



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/ImageVersionGallery.js